import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import {
  Search,
  XLg,
  ThreeDotsVertical,
  EmojiSmile,
} from "react-bootstrap-icons";
import { Dropdown, Button, Alert, Image, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WardValidation from "../../../../hooks/WardValidation";
import {
  occupiedBedsList,
  extendEdd,
  modifyEdd,
  releaseOccupiedBed,
} from "../../../../store/actions/bedsAction";
import ToggleButton from "react-bootstrap/ToggleButton";
import alert from "../../../../assets/images/alert.png";
import ManageWard from "../ManageWard";
import grayBox from "../../../../assets/images/grayBox.png";
import greenBox from "../../../../assets/images/greenBox.png";
import blueBox from "../../../../assets/images/blueBox.png";
import EditImg from "../../../../assets/images/edit.png";
import ProfileImage from "../../../../assets/images/profile.svg";
import Loader from "../../../common/loader/Loader";
import redBox from "../../../../assets/images/red.png";
import yellowBox from "../../../../assets/images/yellow.png";
import smileEmoji from "../../../../assets/svg/Yellow_Flag.svg";
import redEmoji from "../../../../assets/svg/Red_Flag.svg";
import { resetPopup } from "../../../../store/reducerSlice/beds";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";
// card
import Card from "react-bootstrap/Card";
import availableWard from "../../../../assets/images/availableWard.png";
import greenBed from "../../../../assets/images/greenBed.png";
import redBed from "../../../../assets/images/redBed.png";
import yellowBed from "../../../../assets/images/yellowBed.png";
import EditOccupied from "./EditOccupied";
import moment from "moment";
import styles from "../../../common/modal/Popup.module.css";

const OccupiedBeds = () => {
  const [adate, setADate] = useState(null);
  const { wardId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleClose2 = () => setShow2(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show3, setShow3] = useState(false);
  const [selectBed, setSelectBed] = useState(null);
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [isActionCalledModify, setIsActionCalledModify] = useState(false);
  const [reasonOfExtend, setReasonOfExtend] = useState(null);
  const [medicalReason, setMedicalReason] = useState(null);
  const [rehabReason, setRehabReason] = useState(null);
  const [radioValue, setRadioValue] = useState("Medical");
  const [currentEDD, setCurrentEDD] = useState(null);
  const [dateOfAdmission, setDateOfAdmission] = useState(null);
  const [newEDD, setNewEDD] = useState(null);
  const [extendType, setExtendType] = useState(null);
  const [isExtendError, setIsExtendError] = useState(false);
  const [today, setToday] = useState(moment().format("DD/MM/YYYY"));
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    WardValidation({
      currentEDD: currentEDD,
      newEDD: newEDD,
      // reasonOfExtend: reasonOfExtend ? reasonOfExtend : null,
      // medicalReason: medicalReason ? medicalReason : null,
      // rehabReason:rehabReason
    });
  const hideHandler = () => {
    resetAllValidator();
    setShow1(false);
  };

  const handleShow = (val, e) => {
    setShow(true);
    setSelectBed(val);
  };
  const handleShow2 = (val, e) => {
    setSelectBed(val);
    setCurrentEDD(moment(val?.currentEDD).format("YYYY-MM-DD"));
    setNewEDD(moment(val?.newEDD).format("YYYY-MM-DD"));
    setDateOfAdmission(moment(val?.dateOfAdmission).format("YYYY-MM-DD"));
    setShow2(true);
  };
  const handleClose1 = () => {
    resetAllValidator();
    console.log("handler close1");
    setReasonOfExtend(null);
    setMedicalReason(null);
    setRehabReason(null);
    setExtendType(null);
    setRadioValue("Medical");
    setShow1(false);
  };
  const handleShow1 = (val, e) => {
    setSelectBed(val);
    setCurrentEDD(moment(val?.currentEDD).format("YYYY-MM-DD"));
    if (val?.newEDD) {
      setNewEDD(moment(val?.newEDD).format("YYYY-MM-DD"));
    } else {
      setNewEDD(null);
    }
    // setNewEDD(moment(val?.newEDD).format("YYYY-MM-DD"));
    setDateOfAdmission(moment(val?.dateOfAdmission).format("YYYY-MM-DD"));
    setShow1(true);
    setIsExtendError(false);
  };
  // modify
  const subtractDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - days);
    return newDate.toISOString().split("T")[0];
  };

  const handleClose3 = () => {
    resetAllValidator();
    console.log("handler close1");
    setReasonOfExtend(null);
    setMedicalReason(null);
    setRehabReason(null);
    setExtendType(null);
    setRadioValue("Medical");

    setShow3(false);
  };
  const handleShow3 = (val, e) => {
    setSelectBed(val);
    setCurrentEDD(moment(val?.currentEDD).format("YYYY-MM-DD"));
    setDateOfAdmission(moment(val?.dateOfAdmission).format("YYYY-MM-DD"));
    // Subtract one day from the current date
    // Subtract one day from the newEDD date
    if (val?.newEDD) {
      const newEDDDate = moment(val?.newEDD)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      setNewEDD(newEDDDate);
    } else {
      setNewEDD(null);
    }

    setShow3(true);
    setIsExtendError(false);
  };

  const {
    isBedRecordUpdated,
    error: apiError,
    isLoader,
    occupiedBeds,
  } = useSelector((state) => state.beds);

  useEffect(() => {
    dispatch(occupiedBedsList({ wardId })).then(({ payload }) => {
      if (payload?.success) {
        console.log("payload?.data", payload?.data);
      }
    });
  }, []);

  useEffect(() => {
    if (isBedRecordUpdated) {
      dispatch(occupiedBedsList({ wardId })).then(({ payload }) => {
        if (payload?.success) {
          console.log("payload?.data", payload?.data);
        }
      });
    }
  }, [isBedRecordUpdated]);
  const submitModifyHandler = (e) => {
    console.log("isaction called", isActionCalledModify);
    e.preventDefault();
    checkValidator();
    setIsActionCalledModify(true);
  };
  useEffect(() => {
    console.log("isaction called", isActionCalledModify);
    console.log("selectbed", selectBed);
    console.log("radio value ", radioValue);
    // if (!radioValue) {
    //   setIsActionCalledModify(false);
    //   return setIsExtendError("Please select any one reason");
    // }

    let formData = {
      wardId: wardId,
      bedId: selectBed?._id,
      // currentEDD: currentEDD,
      newEDD: newEDD,
    };
    console.log("formdata", formData);
    console.log("error found", isError());
    console.log("error found", error);
    console.log("isExtendError", isExtendError);
    if (!isError() && error !== null && isActionCalledModify) {
      console.log("no error found");
      dispatch(modifyEdd(formData)).then(({ payload }) => {
        console.log("payload", payload);
        if (payload.success) {
          handleClose3();
          setSuccessMessage(payload?.message);
          setIsShow(true);
        } else {
          setIsShow(true);
        }
        setIsActionCalledModify(false);
      });
    } else {
      console.log("error found", error, isError());
      setIsActionCalledModify(false);
    }
  }, [isActionCalledModify]);

  const submitHandler = (e) => {
    console.log("isaction called", isActionCalled);
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
    if (radioValue == "Medical") {
      console.log("radio medicalReason ", medicalReason);
      if (medicalReason == null) {
        setIsExtendError("Please describe reason for delay.");
        setIsActionCalled(false);
      }
    }
    if (radioValue == "Delay") {
      console.log("radio reasonOfExtend ", reasonOfExtend);
      if (reasonOfExtend == null) {
        setIsExtendError("Please select reason for delay.");
        setIsActionCalled(false);
      }
    }
    if (radioValue == "Rehab") {
      console.log("radio rehabReason ", rehabReason);
      if (rehabReason == null) {
        setIsExtendError("Please describe reason for delay.");
        setIsActionCalled(false);
      }
    }
  };

  useEffect(() => {
    console.log("isaction called", isActionCalled);
    console.log("selectbed", selectBed);
    console.log("radio value ", radioValue);
    // if (!radioValue) {
    //   setIsActionCalledModify(false);
    //   return setIsExtendError("Please select any one reason");
    // }

    let formData = {
      wardId: wardId,
      bedId: selectBed?._id,
      // currentEDD: currentEDD,
      newEDD: newEDD,
      extendType: extendType,
      reasonOfExtend: reasonOfExtend,
      medicalReason: medicalReason,
      rehabReason: rehabReason,
    };
    console.log("formdata", formData);
    console.log("error found", isError());
    console.log("error found", error);
    console.log("isExtendError", isExtendError);
    if (!isError() && error !== null && isActionCalled && !isExtendError) {
      console.log("no error found");
      dispatch(extendEdd(formData)).then(({ payload }) => {
        console.log("payload", payload);
        if (payload.success) {
          handleClose1();
          setSuccessMessage("Date extended successfully.");
          setIsShow(true);
        } else {
          setIsShow(true);
        }
        setIsActionCalled(false);
      });
    } else {
      console.log("error found", error, isError());
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const getDate = (val) => {
    let dt = new Date(val);
    return moment(dt).format("DD/MM/YYYY");
  };
  const releaseBed = (e) => {
    e.preventDefault();
    console.log("selectBed inside releasebed", selectBed);
    dispatch(
      releaseOccupiedBed({ wardId: wardId, bedId: selectBed?._id })
    ).then(({ payload }) => {
      console.log("payload", payload);
      if (payload.success) {
        handleClose2();
      } else {
        setIsShow(true);
      }
    });
  };
  const hideHandlerRes = () => {
    dispatch(resetPopup());
    setTitle(null);
    setMessage(null);
    setShowResult(false);
    setIsShow(false);
  };
  return (
    <>
      <EditOccupied
        show={show}
        onHide={handleClose}
        title={selectBed ? "Occupied" : "Occupy Bed"}
        selectBed={selectBed}
      />
      {/* Modal Expend EDD */}
      <Modal
        show={show1}
        onHide={handleClose1}
        aria-labelledby="contained-modal-title-vcenter"
        className={styles.modal}
        centered
      >
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            New EDD
          </h4>
        </Modal.Header>
        <Modal.Body className="px-5 extendModel">
          <Form.Group className="mb-3">
            <Form.Label>Estimated Date Of Discharge</Form.Label>
            <Form.Control
              disabled
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="currentEDD"
              value={currentEDD}
              min={
                currentEDD
                  ? currentEDD
                  : adate && adate?.getFullYear()
                  ? adate?.getFullYear() +
                    "-" +
                    ("0" + (adate?.getMonth() + 1).toString()).substr(-2) +
                    "-" +
                    ("0" + adate?.getDate()).substr(-2)
                  : ""
              }
              onChange={(e) => {
                setCurrentEDD(e.target.value);
                resetValidator(e.target.name);
              }}
              isInvalid={error && error?.currentEDD}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>New Estimated Date Of Discharge</Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="newEDD"
              value={!newEDD == null ? newEDD : null}
              min={
                newEDD !== null && currentEDD
                  ? newEDD
                  : newEDD === null && currentEDD
                  ? currentEDD
                  : adate && adate?.getFullYear()
                  ? adate?.getFullYear() +
                    "-" +
                    ("0" + (adate?.getMonth() + 1).toString()).substr(-2) +
                    "-" +
                    ("0" + adate?.getDate()).substr(-2)
                  : ""
              }
              onChange={(e) => {
                setNewEDD(e.target.value);
                resetValidator(e.target.name);
              }}
              isInvalid={error && error?.newEDD}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Reason</Form.Label>

            <div className="d-flex ">
              <Form.Check
                checked={radioValue === "Medical"}
                name="category"
                value="Medical"
                onClick={(e) => {
                  console.log("clicked down");
                  setRadioValue(e.target.value);
                  setMedicalReason(null);
                }}
                className="me-4"
                type="radio"
                label="Medical"
              />
              <Form.Check
                checked={radioValue === "Delay"}
                name="category"
                value="Delay"
                onClick={(e) => {
                  console.log("clicked down");
                  setRadioValue(e.target.value);
                  setReasonOfExtend(null);
                }}
                className="me-4"
                type="radio"
                label="Delay"
              />
              <Form.Check
                checked={radioValue === "Rehab"}
                name="category"
                value="Rehab"
                onClick={(e) => {
                  console.log("clicked down");
                  setRadioValue(e.target.value);
                  setRehabReason(null);
                }}
                className="me-4"
                type="radio"
                label="Rehab"
              />
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            {/* <Form.Label>Select Reason</Form.Label> */}
            {radioValue == "Delay" ? (
              <>
                <Form.Label>Select Reason</Form.Label>
                <Form.Select
                  className="formSelectWidth"
                  aria-label=" select "
                  name="reasonOfExtend"
                  onChange={(e) => {
                    console.log("selected");
                    setReasonOfExtend(e.target.value);
                    setMedicalReason(null);
                    setRehabReason(null);
                    setIsExtendError(false);
                    setExtendType("Delay");
                  }}
                >
                  <option style={{ display: "none" }} value="">
                    Select
                  </option>
                  <option
                    className="text-wrap"
                    value="LA"
                    style={{ width: "40px" }}
                  >
                    LA
                  </option>
                  <option
                    className="text-wrap text-truncate"
                    style={{ width: "40px" }}
                    value="awaiting discharge to local authority beds"
                  >
                    Awaiting discharge
                    <br /> to local authority beds
                  </option>
                  <option
                    className="text-wrap text-truncate"
                    style={{ width: "40px" }}
                    value="awaiting discharge home with domiciliary care including reablement"
                  >
                    Awaiting discharge home with domiciliary care including
                    reablement
                  </option>
                  <option
                    className="text-wrap"
                    style={{ width: "40px" }}
                    value="awaiting equipment"
                  >
                    Awaiting equipment
                  </option>
                </Form.Select>
              </>
            ) : radioValue == "Rehab" ? (
              <>
                <Form.Label>Describe Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter reason"
                  autoFocus
                  name="rehabReason"
                  onChange={(e) => {
                    console.log("type reason");
                    console.log("rehabReason", rehabReason);
                    console.log("isExtendError", isExtendError);
                    setRehabReason(e.target.value);
                    setReasonOfExtend(null);
                    setMedicalReason(null);
                    setIsExtendError(false);
                    setExtendType("Rehab");
                  }}
                />
              </>
            ) : (
              <>
                {radioValue == "Medical" ? (
                  <>
                    <Form.Label>Describe Reason</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter reason"
                      autoFocus
                      name="medicalReason"
                      onChange={(e) => {
                        console.log("type reason");
                        console.log("medicalReason", medicalReason);
                        console.log("isExtendError", isExtendError);
                        setMedicalReason(e.target.value);
                        setReasonOfExtend(null);
                        setRehabReason(null);
                        setIsExtendError(false);
                        setExtendType("Medical");
                      }}
                    />
                  </>
                ) : (
                  <span style={{ color: "blueviolet", fontSize: "12px" }}>
                    Note:- Please select any reason
                  </span>
                )}
              </>
            )}

            {/* <Form.Control.Feedback type="invalid">
              {error && error?.reasonOfExtend}
            </Form.Control.Feedback> */}
          </Form.Group>
          {isExtendError && (
            <p style={{ color: "red", fontSize: "12px" }}>{isExtendError}</p>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around">
          <span className="cancel-btn" onClick={handleClose1}>
            Cancel
          </span>
          <Button
            variant="primary"
            className="model-btn"
            onClick={(e) => submitHandler(e)}
          >
            New EDD
          </Button>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      {/* Modal Modify EDD */}
      <Modal
        show={show3}
        onHide={handleClose3}
        aria-labelledby="contained-modal-title-vcenter"
        className={styles.modal}
        centered
      >
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Modify EDD
          </h4>
        </Modal.Header>
        <Modal.Body className="px-5 extendModel">
          {/* <Form.Group className="mb-3">
            <Form.Label>Estimated Date Of Discharge</Form.Label>
            <Form.Control
              disabled
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="currentEDD"
              value={currentEDD}
              min={
                currentEDD
                  ? currentEDD
                  : adate && adate?.getFullYear()
                  ? adate?.getFullYear() +
                    "-" +
                    ("0" + (adate?.getMonth() + 1).toString()).substr(-2) +
                    "-" +
                    ("0" + adate?.getDate()).substr(-2)
                  : ""
              }
              onChange={(e) => {
                setCurrentEDD(e.target.value);
                resetValidator(e.target.name);
              }}
              isInvalid={error && error?.currentEDD}
            />
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label>New Estimated Date Of Discharge </Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="newEDD"
              value={newEDD ? newEDD : currentEDD} // Convert newEDD to the correct format
              min={
                dateOfAdmission &&
                new Date(dateOfAdmission) &&
                moment(dateOfAdmission).format("YYYY-MM-DD")
              }
              max={
                dateOfAdmission &&
                new Date(dateOfAdmission) &&
                moment(dateOfAdmission).add(13, "day").format("YYYY-MM-DD")
              }
              onChange={(e) => {
                setNewEDD(e.target.value);
                resetValidator(e.target.name);
              }}
              isInvalid={error && error?.newEDD}
            />

            <Form.Control.Feedback type="invalid">
              {error && error?.newEDD}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around">
          <span className="cancel-btn" onClick={handleClose3}>
            Cancel
          </span>
          <Button
            variant="primary"
            className="model-btn"
            onClick={(e) => submitModifyHandler(e)}
          >
            Modify EDD
          </Button>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      {/* Modal Release */}
      <Modal
        show={show2}
        onHide={handleClose2}
        aria-labelledby="contained-modal-title-vcenter"
        className={styles.modal}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body align="center">
          <img src={alert} />
          <h4>Release Bed</h4>
          <div>
            <p>Are you sure you want to release bed?</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around">
          <span className="cancel-btn" onClick={handleClose2}>
            No
          </span>
          <Button
            variant="primary"
            className="model-btn"
            onClick={(e) => releaseBed(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      <div className="occupied-card  shadow p-4 mb-5 bg-white rounded">
        <Row xs={1} md={3} className="g-4">
          {occupiedBeds &&
            occupiedBeds.map((bed) => (
              <Col key={bed?._id}>
                <Card>
                  <Card.Body className="bed-card">
                    <div className="d-flex card-top">
                      {bed?.socialCareNeed == "LOW" ? (
                        <Card.Img
                          variant="left"
                          className="p-2"
                          style={{ width: "72px", height: "72px" }}
                          src={greenBed}
                        />
                      ) : bed?.socialCareNeed == "MODERATE" ? (
                        <Card.Img
                          variant="left"
                          className="p-2"
                          style={{ width: "72px", height: "72px" }}
                          src={yellowBed}
                        />
                      ) : (
                        <Card.Img
                          variant="left"
                          className="p-2"
                          style={{ width: "72px", height: "72px" }}
                          src={redBed}
                        />
                      )}

                      <Card.Title 
                       onClick={bed?.newEDD ? undefined : (e) => handleShow(bed, e) }
                        style={{
                          fontSize: "15px",
                          marginTop: "14px",
                          fontWeight: "800",
                          marginLeft: "4px",
                          cursor: "pointer",
                          width: "150px",
                        }}
                      >
                        Occupied
                        {/* <br />
                        <span className="patientName">
                          {bed?.patientInitials ? bed?.patientInitials : "\u00A0"}
                        </span> */}
                        
                        <p className="text-nowrap">
                          <span>NHS No.:</span> {bed?.nhsNumber}
                        </p>
                        <p className="text-nowrap" style={{marginTop:'-10px'}}>
                          <span>Patient Initials:</span> {bed?.patientInitials ? bed?.patientInitials : "\u00A0"}
                        </p>
                      </Card.Title>
                      <div style={{ float: "right" }}>
                        {getDate(bed?.newEDD ? bed?.newEDD : bed?.currentEDD) ==
                        today ? (
                          <img className="smileEmoji" src={smileEmoji} />
                        ) : (
                          ""
                        )}

                        {/* {getDate(bed?.currentEDD) < today ? 
                          <img className="smileEmoji" src={redEmoji} />
                        : 
                          ""
                        } */}
                        {moment(bed?.newEDD ? bed?.newEDD : bed?.currentEDD)
                          ?.startOf("day")
                          .isBefore(moment()?.startOf("day")) ? (
                          <img className="smileEmoji" src={redEmoji} />
                        ) : (
                          ""
                        )}

                        <Dropdown align="end">
                          <Dropdown.Toggle variant="none">
                            <ThreeDotsVertical />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            {bed?.newEDD ? (
                              ""
                            ) : (
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleShow(bed, e)}
                              >
                                Edit Bed
                              </Dropdown.Item>
                            )}

                            <Dropdown.Item
                              href="#"
                              onClick={() =>
                                navigate(`/audit-trail-bed/${bed._id}`)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              Audit Trails
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <Card.Text>
                      <span>Date of Admission: </span>{" "}
                      <span>{getDate(bed?.dateOfAdmission)}</span>
                    </Card.Text>
                    <Card.Text>
                      <span>Estimated Date of Discharge: </span>{" "}
                      <span>{getDate(bed?.currentEDD)}</span>
                    </Card.Text>
                    <Card.Text>
                      <span>New EDD: </span>{" "}
                      <span>
                        {bed?.newEDD ? (
                          <>
                            <span style={{ fontWeight: "700", color: "#333" }}>
                              {getDate(bed?.newEDD)} ({bed?.extendType})
                            </span>
                          </>
                        ) : (
                          <span>none</span>
                        )}
                      </span>
                    </Card.Text>
                    <Card.Text>
                      <span>Dependency Score: </span> {bed?.socialCareNeed}
                    </Card.Text>
                    <div className="group-body ">
                      <span
                        className="btn2 me-2"
                        onClick={(e) => handleShow3(bed, e)}
                      >
                        Modify EDD
                      </span>

                      <span
                        className="btn1 me-2"
                        onClick={(e) => handleShow2(bed, e)}
                      >
                        Free Bed
                      </span>
                      <span
                        className="btn2"
                        onClick={(e) => handleShow1(bed, e)}
                      >
                        Delay EDD
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </div>
      {/* popup */}
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordUpdated: isShow,
          successMsg: successMessage,
          title: "",
          errorRes: apiError?.message,
        }}
      />
    </>
  );
};

export default OccupiedBeds;
